import Header from "../Header";
import Main from "../Main";
import Footer from "../Footer";

function LayoutDefault() {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default LayoutDefault;
